import { ContentPill } from './ContentPill'
import theme from '@root/styles/theme'
import { useTranslation } from 'react-i18next'
import { AuditTrailFields, IAuditTrailObjectBase, IChangeDocument } from '@root/query/auditTrail'
import { useBusinessContext, useFlag, useFlagsLoaded } from '@root/context'
import { getSettingsPageUrl, getWorkflowsPageUrl } from '@root/constants'
import styled from 'styled-components'
import { ISimpleAccountingRule } from '@root/query'
import { FaBook } from 'react-icons/fa'

interface Props {
  auditRecord: IAuditTrailObjectBase<IChangeDocument>
}

export const findRuleChange = (changes: IChangeDocument[]): IChangeDocument | undefined =>
  changes.find(change => change.field === AuditTrailFields.RULE) ?? undefined

export const RuleBlock: React.FC<Props> = ({ auditRecord }) => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()
  const flagsLoaded = useFlagsLoaded()
  const workflowsFlag = useFlag('workflows')
  const workflowsHubEnabled = flagsLoaded && workflowsFlag.enabled

  if (!auditRecord?.changes || auditRecord.changes.length === 0) {
    return null
  }

  const ruleChange = findRuleChange(auditRecord.changes)

  const RuleIcon = <FaBook style={{ color: theme.colors.iconGrayDark }} />

  const rule = ruleChange?.new_values as ISimpleAccountingRule

  const automationSettingsUrl = workflowsHubEnabled
    ? getWorkflowsPageUrl(slug, { tab: 'rules', id: rule?.id })
    : getSettingsPageUrl(slug, { page: 'automation-rules', id: rule?.id })

  return (
    <RulesContainer>
      {rule ? (
        <ContentPill url={automationSettingsUrl} Icon={RuleIcon} text={rule.name} />
      ) : (
        <ContentPill
          Icon={RuleIcon}
          text={t('components.auditTrail.noRuleFound')}
          info={t('components.auditTrail.noRuleFoundInfo')}
        />
      )}
    </RulesContainer>
  )
}

const RulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  width: fit-content;
`
